
  import { defineComponent, ref, computed } from 'vue';
  import AdsFilterWidgets from '@/components/dropdown/AdsFilterWidgets.vue';
  import { getCSSVariableValue } from '@/assets/ts/_utils';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { reinitializeComponents } from '@/core/plugins/keenthemes';

  export default defineComponent({
    name: 'auction-widget',
    components: {
      AdsFilterWidgets,
    },
    props: {
      widgetClasses: String,
      chartColor: String,
      chartHeight: String,
    },
    async setup(props) {
      const loading = ref(true);
      const store = useStore();
      await store.dispatch(Actions.GET_AUCTIONS_DASHBOARD);
      const data = store.getters.auctionsDashboard;

      const color = ref(props.chartColor);

      const labelColor = getCSSVariableValue('--bs-' + 'gray-800');
      const strokeColor = getCSSVariableValue('--bs-' + 'gray-300');
      const baseColor = getCSSVariableValue('--bs-' + color.value);
      const lightColor = getCSSVariableValue('--bs-light-' + color.value);

      const MONTHS = {
        1: 'Jan',
        2: 'Feb',
        3: 'Mar',
        4: 'Apr',
        5: 'May',
        6: 'Jun',
        7: 'Jul',
        8: 'Aug',
        9: 'Sep',
        10: 'Oct',
        11: 'Nov',
        12: 'Dec',
      };

      const chartMonth = data.data.countPerMonth.map(
        (item) => MONTHS[item.month]
      );
      const chartCount = data.data.countPerMonth.map((item) => item.count);

      setTimeout(() => {
        loading.value = false;
      }, 900);

      const chartOptions = {
        chart: {
          fontFamily: 'inherit',
          type: 'area',
          height: props.chartHeight,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {},
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: 'solid',
          opacity: 1,
        },
        stroke: {
          curve: 'smooth',
          show: true,
          width: 3,
          colors: [baseColor],
        },
        xaxis: {
          categories: chartMonth,
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            style: {
              colors: labelColor,
              fontSize: '12px',
            },
          },
          crosshairs: {
            show: false,
            position: 'front',
            stroke: {
              color: strokeColor,
              width: 1,
              dashArray: 3,
            },
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          min: 0,
          max: 35,
          labels: {
            show: false,
            style: {
              colors: labelColor,
              fontSize: '12px',
            },
          },
        },
        states: {
          normal: {
            filter: {
              type: 'none',
              value: 0,
            },
          },
          hover: {
            filter: {
              type: 'none',
              value: 0,
            },
          },
          active: {
            allowMultipleDataPointsSelection: false,
            filter: {
              type: 'none',
              value: 0,
            },
          },
        },
        tooltip: {
          style: {
            fontSize: '12px',
          },
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
        colors: [lightColor],
        markers: {
          colors: [lightColor],
          strokeColor: [baseColor],
          strokeWidth: 3,
        },
      };

      // const objMonth = data.data.
      const series = [
        {
          name: 'Number Of Auctions',
          data: chartCount,
        },
      ];

      const onTypeChange = async (values) => {
        loading.value = true;
        await store.dispatch(
          Actions.UPDATE_AUCTIONS_DASHBOARD_FILTER,
          values.value
        );
        await store.dispatch(Actions.GET_AUCTIONS_DASHBOARD, values);
        setTimeout(() => {
          loading.value = false;
          reinitializeComponents();
        }, 900);
      };
      const onReset = async (value) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_AUCTIONS_DASHBOARD_FILTER, value);
        await store.dispatch(Actions.GET_AUCTIONS_DASHBOARD);
        loading.value = false;
      };

      reinitializeComponents();

      return {
        onTypeChange,
        onReset,
        data: computed(() => store.getters.auctionsDashboard),
        loading,
        color,
        series,
        chartOptions,
      };
    },
  });
